"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var text_input_1 = __importDefault(require("../../atoms/text-input"));
var textarea_1 = __importDefault(require("../../atoms/textarea"));
var select_1 = __importDefault(require("../../atoms/select"));
var switch_1 = __importDefault(require("../../atoms/switch"));
var radio_1 = __importDefault(require("../../atoms/radio"));
var field_1 = __importDefault(require("./field"));
var actions_1 = __importDefault(require("./actions"));
var fieldset_1 = __importDefault(require("./fieldset"));
var form_context_1 = __importDefault(require("./form-context"));
var Form = function (props) { return (React.createElement(form_context_1.default.Provider, { value: { layout: props.layout, fullWidth: props.fullWidth } },
    React.createElement(Form.Element, __assign({}, props, automation_attribute_1.default('form'))))); };
Form.Field = field_1.default;
Form.TextInput = function (props) { return React.createElement(field_1.default, __assign({}, props, { fieldComponent: text_input_1.default })); };
Form.TextArea = function (props) { return React.createElement(field_1.default, __assign({}, props, { fieldComponent: textarea_1.default })); };
Form.Select = function (props) { return React.createElement(field_1.default, __assign({}, props, { fieldComponent: select_1.default })); };
Form.Switch = function (props) { return React.createElement(field_1.default, __assign({}, props, { fieldComponent: switch_1.default })); };
var FormRadio = (function () {
    var Radio = function (props) { return React.createElement(field_1.default, __assign({}, props, { fieldComponent: radio_1.default })); };
    Radio.Option = radio_1.default.Option;
    return Radio;
})();
Form.Radio = FormRadio;
Form.Actions = actions_1.default;
Form.FieldSet = fieldset_1.default;
Form.Element = styled_1.default.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ", ", " {\n    max-width: ", ";\n  }\n"], ["\n  ", ", ", " {\n    max-width: ", ";\n  }\n"])), field_1.default.Element, actions_1.default.Element, function (props) { return (props.layout === 'label-on-top' || props.fullWidth ? 'auto' : '624px'); });
Form.defaultProps = {
    layout: 'label-on-left'
};
exports.default = Form;
var templateObject_1;
//# sourceMappingURL=form.js.map